import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

export const UpdateMYP = gql`
  mutation UpdateMYP($percentage: Percentage!) {
    updateMYP(input: { percentage: $percentage }) {
      __typename
      ... on UpdateMYPSuccess {
        isFirstTime
        key
        myp {
          id
          percentage
        }
      }
      ... on UpdateMYPError {
        ...error
      }
    }
  }
  ${error}
`;
